import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-search-results',
    standalone: true,
    imports: [TranslateModule, CommonModule],
    templateUrl: './search-results.component.html',
})
export class SearchResultsComponent {
    @Input() searchResults: any = [];
    @Input() selectedLanguage: string = 'en';
    @Output() searchQuestion = new EventEmitter<any>();

    searchForQuestion(item: any) {
        this.searchQuestion.emit(item);
    }

    stripHtml(html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || '';
    }
}
